export enum HighCommissionBoosting {
  NAME = 'plp_hc_boosting',
  OFF = 'off',
  ON = 'on',
}

export enum ClpSaleBury {
  BURY = 'bury',
  NAME = 'clp_sale_bury',
  NO_BURY = 'no_bury',
}

export enum ClpPopulation {
  AUTO = 'auto',
  NAME = 'clp_population',
  QUERY = 'query',
}
